import { render, staticRenderFns } from "./overside.vue?vue&type=template&id=35b19326&scoped=true&"
import script from "./overside.vue?vue&type=script&lang=js&"
export * from "./overside.vue?vue&type=script&lang=js&"
import style0 from "./overside.vue?vue&type=style&index=0&id=35b19326&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b19326",
  null
  
)

export default component.exports